// tabs/SettingsParentTab.js
import React, { useState } from "react";
import BillingSettingsTab from "./BillingSettingsTab";
import RecipientsTab from "./RecipientsTab";
import PricingTab from "./PricingTab";

function SettingsParentTab({ facilities }) {
  const [activeChildTab, setActiveChildTab] = useState("billing-settings");

  const renderChildTabContent = () => {
    switch (activeChildTab) {
      case "billing-settings":
        return <BillingSettingsTab />;
      case "recipients":
        return <RecipientsTab facilities={facilities} />;
      case "pricing":
        return <PricingTab facilities={facilities} />;
      default:
        return null;
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="mb-4">
        <h4 className="mb-1">
          <i className="ti ti-settings me-2 text-primary"></i>
          Billing Settings
        </h4>
        <p className="text-muted mb-0">
          Configure billing settings, recipients and pricing
        </p>
      </div>

      {/* Child Tabs Navigation */}
      <ul className="nav nav-tabs mb-3" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-link ${activeChildTab === "billing-settings" ? "active" : ""}`}
            onClick={() => setActiveChildTab("billing-settings")}
            role="tab"
            style={{ cursor: "pointer" }}
          >
            <i className="ti ti-receipt me-2"></i>
            Billing Settings
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeChildTab === "recipients" ? "active" : ""}`}
            onClick={() => setActiveChildTab("recipients")}
            role="tab"
            style={{ cursor: "pointer" }}
          >
            <i className="ti ti-users me-2"></i>
            Recipients
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeChildTab === "pricing" ? "active" : ""}`}
            onClick={() => setActiveChildTab("pricing")}
            role="tab"
            style={{ cursor: "pointer" }}
          >
            <i className="ti ti-receipt me-2"></i>
            Module Pricing
          </a>
        </li>
      </ul>

      {/* Child Tab Content */}
      {renderChildTabContent()}
    </div>
  );
}

export default SettingsParentTab;
